import { operatorsJson } from "@corca/data";
import { omit, pick } from "es-toolkit";

import { createKeyMap } from "@/utils/createKeyMap";

import type { Operator, OperatorTypeValue } from "@corca/data";

export const OperatorType = createKeyMap(operatorsJson);

export type FlattenOperator = Operator & { operatorType: OperatorTypeValue };

const flattenOperators = getFlattenOperators(operatorsJson);

function getFlattenOperators(ops: Record<OperatorTypeValue, Operator>): FlattenOperator[] {
  return Object.entries(ops).reduce((acc, [opType, op]) => {
    if (op.variants) {
      for (const variant of op.variants) {
        acc.push({
          ...omit(op, ["variants"]),
          ...variant,
          operatorType: opType as OperatorTypeValue,
        });
      }
      return acc;
    }
    acc.push({ ...op, operatorType: opType as OperatorTypeValue });
    return acc;
  }, [] as FlattenOperator[]);
}

function getFlattenOperatorsByType(
  operatorType: OperatorTypeValue | OperatorTypeValue[],
): FlattenOperator[] {
  const types = Array.isArray(operatorType) ? operatorType : [operatorType];
  return getFlattenOperators(pick(operatorsJson, types));
}

export { operatorsJson as operators, flattenOperators, getFlattenOperatorsByType };
